import styled from 'styled-components';
import { colors } from '../theme/colors';

export const AdminShell = styled.div`
  min-height: 100vh;
  background: ${colors.bg};
  color: ${colors.ink};
`;

export const AdminTopBar = styled.header`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 24px;
  border-bottom: 1px solid ${colors.border};
  background: ${colors.bgAlt};
`;

export const AdminBrand = styled.div`
  font-size: 18px;
  font-weight: 900;
  letter-spacing: -0.02em;
`;

export const AdminNav = styled.nav`
  display: flex;
  gap: 12px;
  margin-left: auto;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  color: ${colors.inkMuted};

  a {
    text-decoration: none;
    color: ${colors.inkSoft};
    &:hover { color: ${colors.ink}; }
  }
`;

export const AdminMain = styled.main`
  max-width: 1100px;
  margin: 0 auto;
  padding: 24px 20px 48px;
`;

export const PageTitle = styled.h1`
  margin: 0 0 8px;
  font-size: 26px;
  font-weight: 900;
  letter-spacing: -0.03em;
`;

export const PageSubtitle = styled.p`
  margin: 0 0 24px;
  color: ${colors.inkMuted};
  font-size: 14px;
`;

export const Card = styled.div`
  background: ${colors.bgAlt};
  border: 1px solid ${colors.border};
  border-radius: 16px;
  padding: 18px 20px;
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 14px;
`;

export const StatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 12px;
  margin-bottom: 24px;
`;

export const StatCard = styled.div`
  background: ${colors.bgAlt};
  border: 1px solid ${colors.border};
  border-radius: 14px;
  padding: 14px 16px;
`;

export const StatLabel = styled.div`
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.inkMuted};
  margin-bottom: 6px;
`;

export const StatValue = styled.div`
  font-size: 22px;
  font-weight: 900;
  color: ${colors.ink};
`;

export const Btn = styled.button`
  appearance: none;
  border: none;
  border-radius: 12px;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  background: ${(p) => (p.$primary ? colors.primary : colors.bgAlt)};
  color: ${(p) => (p.$primary ? colors.primaryText : colors.ink)};
  border: ${(p) => (p.$primary ? 'none' : `1px solid ${colors.border}`)};
  opacity: ${(p) => (p.disabled ? 0.55 : 1)};
  &:hover:not(:disabled) { opacity: 0.9; }
`;

export const BtnDanger = styled(Btn)`
  background: transparent;
  color: #b91c1c;
  border: 1.5px solid #fecaca;
`;

export const BtnRow = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 20px;
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 14px;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${colors.inkMuted};

  input, textarea, select {
    font-size: 14px;
    font-weight: 500;
    text-transform: none;
    letter-spacing: normal;
    color: ${colors.ink};
    border: 1px solid ${colors.border};
    border-radius: 12px;
    padding: 10px 12px;
    background: ${colors.bg};
    font-family: inherit;
  }

  textarea { min-height: 88px; resize: vertical; }
`;

export const ErrorText = styled.p`
  color: #b91c1c;
  font-size: 13px;
  font-weight: 700;
  margin: 8px 0;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  th, td {
    text-align: left;
    padding: 12px 10px;
    border-bottom: 1px solid ${colors.border};
  }

  th {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${colors.inkMuted};
    font-weight: 800;
  }

  tr:hover td { background: rgba(44, 42, 41, 0.03); }
`;

export const Badge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  background: ${(p) => {
    if (p.$status === 'active') return colors.accentSoft;
    if (p.$status === 'ended') return '#f4f4f5';
    return '#fef3c7';
  }};
  color: ${(p) => {
    if (p.$status === 'active') return colors.accent;
    if (p.$status === 'ended') return colors.inkMuted;
    return '#b45309';
  }};
`;

export const LoginCard = styled(Card)`
  max-width: 400px;
  margin: 80px auto;
`;

export const Linkish = styled.a`
  color: ${colors.accent};
  font-weight: 700;
  text-decoration: none;
  &:hover { text-decoration: underline; }
`;
